import {StyledNotificationContainer, StyledNotificationsTitle} from './style'
import {useTranslation} from 'react-i18next'
import {useEffect, useMemo} from 'react'
import {NotificationsContainer} from './notificationsContainer/NotificationsContainer'
import useContainerDimensions from '@/hooks/useContainerDimensions'
import {useGetNotificationsHistory} from '../queries/useGetNotificationsHistory'
import {useSendSeenNotifications} from '../queries/useSendSeenNotifications'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useGetNotificationUnreadCount} from '../queries/useGetNotificationUnreadCount'
import useInfinityLoading from '@/hooks/useInfinityLoading'

export const Notifications = ({closeNotification}: {closeNotification: () => void}) => {
    const {t} = useTranslation()
    const {height: vh} = useContainerDimensions()
    const {data: notificationsData, isLoading, fetchNextPage, hasNextPage} = useGetNotificationsHistory({})
    const [endRef] = useInfinityLoading({fetchFunction: fetchNextPage, dependencies: [hasNextPage]})
    const {mutate: sendSeenNotifications} = useSendSeenNotifications()
    const {data: unreadCounter} = useGetNotificationUnreadCount()
    const notification = useMemo(() => notificationsData?.pages?.flatMap(page => page), [notificationsData])
    useEffect(
        () => () => {
            unreadCounter.count > 0 &&
                notification?.[0].id &&
                sendSeenNotifications({fromNotificationId: notification?.[0].id})
        },
        [unreadCounter, notification]
    )
    const sortedNotifications = useMemo(() => {
        return notification
            ? {
                  new: notification.filter(notification => !notification.seenAt)!,
                  old: notification.filter(notification => notification.seenAt)!
              }
            : {new: [], old: []}
    }, [notification])

    return (
        <StyledNotificationContainer vh={vh}>
            <StyledNotificationsTitle>{t('notifications:title')}</StyledNotificationsTitle>
            {!!sortedNotifications.new.length && (
                <NotificationsContainer notifications={sortedNotifications.new} closeNotification={closeNotification} />
            )}
            {!!sortedNotifications.old.length && (
                <NotificationsContainer
                    notifications={sortedNotifications.old}
                    closeNotification={closeNotification}
                    old
                />
            )}
            {hasNextPage && <div ref={endRef} />}
            {isLoading && <Spinner inline overlay={false} size={30} />}
        </StyledNotificationContainer>
    )
}
